

(function(){
  var section = document.getElementById('cp-bv-section');
  if (!section) return;

  var pid             = window.CP_currentProductId;
  var isClass         = !!window.CP_isClassProduct;
  var allVariants     = window.CP_variants || [];
  var currentVarId    = window.CP_currentVariantId;
  var currentVarPrice = window.CP_currentVariantPrice;
  var currentFormat   = '';
  var relatedProds    = [];

  var EXCL_HANDLE = 'mass-readings-explained-include-trial';
  var PHYSICAL    = ['cd','dvd','blu-ray','blu ray','bluray'];
  var ALL_FORMATS = ['cd','dvd','blu-ray','blu ray','bluray','mp3','digital video'];

  var bundleBody  = document.getElementById('cp-bundle-body');
  var singleBody  = document.getElementById('cp-single-body');
  var volumeBody  = document.getElementById('cp-volume-body');
  var cardBundle  = document.getElementById('cp-card-bundle');
  var cardSingle  = document.getElementById('cp-card-single');
  var cardGroup   = document.getElementById('cp-card-group');
  var cardsRow    = document.getElementById('cp-bv-cards');
  var bundleSub   = document.getElementById('cp-card-bundle-sub');
  var groupSub    = document.getElementById('cp-card-group-sub');
  var atcBtn      = document.getElementById('cp-bv-atc');

  var mode = 'single';
  var bundleLoaded = false;
  var bundleTiers = [];
  var selectedTierIdx = 1;
  var volTiers = [];
  var selectedVolIdx = 1;
  var parishQtyCurrent = null;

  function fillTpl(tpl, vals){
    return String(tpl)
      .replace('{qty}',   vals.qty  != null ? vals.qty         : '')
      .replace('{price}', vals.price!= null ? money(vals.price): '')
      .replace('{save}',  vals.save != null ? money(vals.save) : '');
  }
  function atcLabel(){
    var T = window.CP_atcTemplates || {};
    if(mode==='single') return fillTpl(T.single || 'Add to Cart — {price}', {price:currentVarPrice});
    if(mode==='bundle'){
      var t = bundleTiers[selectedTierIdx];
      if(!(t && t.enough)) return 'Add Bundle to Cart →';
      return fillTpl(T.bundle || 'Save & Add Bundle to Cart →', {save:t.savedAmt});
    }
    var v = volTiers[selectedVolIdx];
    if(!v) return 'Add to Cart →';
    var qty = v.isParish ? (parishQtyCurrent||v.qty) : v.qty;
    var saved = Math.round(v.price*qty*(v.discount/100));
    return fillTpl(T.group || 'Save & Add {qty} Copies to Cart →', {qty:qty, save:saved});
  }

  function money(cents) {
    return '$' + (parseInt(cents,10)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
  function hasTag(tags, name) {
    if (!tags||!tags.length) return false;
    var l = name.toLowerCase();
    return tags.some(function(t){ return t.toLowerCase()===l; });
  }
  function isBook(p)      { return hasTag(p.tags,'book'); }
  function isHiddenSub(p) { return hasTag(p.tags,'subscription') && p.handle!==EXCL_HANDLE; }
  function isPurchased(id){ return (window.CP_purchasedProductIds||[]).indexOf(id)!==-1; }
  function detectFormat(title) {
    var t=(title||'').toLowerCase();
    for(var i=0;i<ALL_FORMATS.length;i++){ if(t.indexOf(ALL_FORMATS[i])!==-1) return ALL_FORMATS[i]; }
    return '';
  }
  function isPhysical(fmt){ return PHYSICAL.indexOf(fmt)!==-1; }

  function findVariantByFormat(variants, fmt) {
    var FALLBACK_CHAINS = {
      'blu-ray':       ['blu-ray','blu ray','bluray','dvd','digital video','cd'],
      'blu ray':       ['blu-ray','blu ray','bluray','dvd','digital video','cd'],
      'bluray':        ['blu-ray','blu ray','bluray','dvd','digital video','cd'],
      'dvd':           ['dvd','digital video','cd'],
      'cd':            ['cd'],
      'digital video': ['digital video','mp3'],
      'mp3':           ['mp3']
    };
    var chain = fmt ? (FALLBACK_CHAINS[fmt] || [fmt]) : [];
    for(var i=0;i<chain.length;i++){
      var f=chain[i];
      var match=variants.filter(function(v){ return v.title.toLowerCase().indexOf(f)!==-1 && v.available; });
      if(match.length) return {variant:match[0], formatUsed:f, isFallback:f!==fmt};
    }
    for(var j=0;j<chain.length;j++){
      var f2=chain[j];
      var match2=variants.filter(function(v){ return v.title.toLowerCase().indexOf(f2)!==-1; });
      if(match2.length) return {variant:match2[0], formatUsed:f2, isFallback:f2!==fmt};
    }
    var av=variants.filter(function(v){return v.available;});
    var fallback=av.length?av[0]:variants[0];
    return {variant:fallback, formatUsed:detectFormat(fallback.title), isFallback:true};
  }

  function formatLabel(fmt) {
    var map={'cd':'CD','dvd':'DVD','blu-ray':'Blu-ray','blu ray':'Blu-ray','bluray':'Blu-ray','mp3':'MP3','digital video':'Digital Video'};
    return map[fmt]||fmt.toUpperCase();
  }
  function getVariantImage(variant) {
    if(variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return section.getAttribute('data-cur-img')||'';
  }
  function appendSize(url, width) {
    if(!url) return '';
    return url+(url.indexOf('?')!==-1?'&':'?')+'width='+width;
  }

  function setPhysicalMode(phys) {

    if(cardGroup) cardGroup.classList.toggle('cp-bv__card--disabled', !phys);

    if(!phys && mode==='group') selectCard('single');
  }

  function markSelectedSwatch(){
    var all = document.querySelectorAll('.swatch-element.cp-chip-sel');
    for(var i=0;i<all.length;i++){ all[i].classList.remove('cp-chip-sel'); }
    if(!currentFormat) return;
    var cls = currentFormat.replace(/\s+/g,'-') + '-swatch';
    var sel = document.querySelectorAll('.swatch-element.' + cls);
    for(var j=0;j<sel.length;j++){ sel[j].classList.add('cp-chip-sel'); }
  }

  function initSwatchClicks(){
    var sw = document.querySelectorAll('.swatch-element');
    for(var i=0;i<sw.length;i++){
      sw[i].addEventListener('click', function(){
        var self = this;
        var marked = document.querySelectorAll('.swatch-element.cp-chip-sel');
        for(var k=0;k<marked.length;k++){ marked[k].classList.remove('cp-chip-sel'); }
        self.classList.add('cp-chip-sel');
      });
    }
  }

  var reAnchorPending = false;
  function scheduleReAnchor(){
    if(reAnchorPending) return; reAnchorPending = true;
    setTimeout(function(){ reAnchorPending = false; reAnchorReviewCard(); }, 160);
  }
  function reAnchorReviewCard(){
    var card = document.querySelector('.cp-fr.cp-fr--desktop') || document.querySelector('.cp-fr');
    var selbox = document.querySelector('.cp-bv__selbox');
    if(!card || !selbox) return;
    var col = card.closest('.five-eighths') || card.offsetParent || card.parentElement;
    if(getComputedStyle(card).position !== 'absolute'){

      if(col) col.style.setProperty('min-height','0px','important');
      return;
    }
    if(!col) return;
    var colTop = col.getBoundingClientRect().top;
    var selBottom = selbox.getBoundingClientRect().bottom;
    var cardH = card.getBoundingClientRect().height;
    var newTop = Math.round(selBottom - colTop - cardH);
    if(newTop < 0) newTop = 0;
    if(parseInt(card.style.top,10) !== newTop){ card.style.setProperty('top', newTop+'px','important'); }
    var desiredMin = newTop + cardH + 24;
    if(parseInt(col.style.minHeight,10) !== desiredMin){ col.style.setProperty('min-height', desiredMin+'px','important'); }
  }
  function initReAnchor(){
    scheduleReAnchor();
    window.addEventListener('load', scheduleReAnchor);
    window.addEventListener('resize', scheduleReAnchor);
    setTimeout(scheduleReAnchor, 400);
    setTimeout(scheduleReAnchor, 1000);
    setTimeout(scheduleReAnchor, 1800);
    var card = document.querySelector('.cp-fr.cp-fr--desktop') || document.querySelector('.cp-fr');
    var selbox = document.querySelector('.cp-bv__selbox');
    if('ResizeObserver' in window){
      var ro = new ResizeObserver(scheduleReAnchor);
      if(selbox) ro.observe(selbox);
      if(card) ro.observe(card);
    }

    if('MutationObserver' in window && card){
      new MutationObserver(scheduleReAnchor).observe(card, {attributes:true, attributeFilter:['style']});
    }
  }

  function applyDiscountCode(code, callback) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = '/discount/' + code;
    iframe.onload = function() { document.body.removeChild(iframe); callback(); };
    iframe.onerror = function() { document.body.removeChild(iframe); callback(); };
    document.body.appendChild(iframe);
  }

  var discountActive = false;

  function clearDiscountCode() {
    if(!discountActive) return;
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = '/discount/CLEAR';
    iframe.onload = function(){ document.body.removeChild(iframe); };
    iframe.onerror = function(){ document.body.removeChild(iframe); };
    document.body.appendChild(iframe);
    discountActive = false;
  }

  function startCartPolling(minQty) {
    discountActive = true;
    var poll = setInterval(function(){
      if(!discountActive){ clearInterval(poll); return; }
      fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(cart.item_count < minQty){ clearDiscountCode(); clearInterval(poll); }
      });
    }, 3000);
  }

  function triggerThemeCart(items, btn, originalLabel, discountCode, minQty) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
    function addToCart() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items: items})
      })
      .then(function(r){ return r.json(); })
      .then(function() {
        btn.textContent = 'Added ✓';
        if(discountCode) startCartPolling(minQty || 2);
        if(window.jQuery){
          jQuery(document).trigger('ajaxProduct.added');
          jQuery(document).trigger('cart.requestComplete');
        }
        var nativeForm = document.querySelector('form[action="/cart/add"]');
        if(nativeForm) nativeForm.dispatchEvent(new CustomEvent('product:added',{bubbles:true}));
        setTimeout(function(){ btn.disabled=false; btn.textContent=originalLabel; updateAtc(); }, 2500);
      })
      .catch(function(){ btn.disabled=false; btn.textContent='Error — Try Again'; });
    }
    if(discountCode) { applyDiscountCode(discountCode, addToCart); } else { addToCart(); }
  }

  function pickMode(m){
    mode = m;
    if(cardBundle) cardBundle.classList.toggle('cp-bv__card--on', m==='bundle');
    if(cardSingle) cardSingle.classList.toggle('cp-bv__card--on', m==='single');
    if(cardGroup)  cardGroup.classList.toggle('cp-bv__card--on', m==='group');
    if(bundleBody) bundleBody.style.display = (m==='bundle')?'block':'none';
    if(singleBody) singleBody.style.display = (m==='single')?'block':'none';
    if(volumeBody) volumeBody.style.display = (m==='group')?'block':'none';
    updateAtc();
  }

  var REDUCE    = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SLIDE_DUR = 520;
  var FADE_DUR  = 360;
  var slots     = ['bundle','single','group'];
  var cardByKey = { single:cardSingle, bundle:cardBundle, group:cardGroup };
  slots.forEach(function(k,i){ if(cardByKey[k]) cardByKey[k].style.order = i; });

  function bodyForMode(m){ return m==='single' ? singleBody : m==='group' ? volumeBody : bundleBody; }
  function activeBody(){ return bodyForMode(mode); }
  function setBodyDisplays(m){
    if(bundleBody) bundleBody.style.display = (m==='bundle')?'block':'none';
    if(singleBody) singleBody.style.display = (m==='single')?'block':'none';
    if(volumeBody) volumeBody.style.display = (m==='group') ?'block':'none';
  }
  function setCardsOn(key){
    if(cardBundle) cardBundle.classList.toggle('cp-bv__card--on', key==='bundle');
    if(cardSingle) cardSingle.classList.toggle('cp-bv__card--on', key==='single');
    if(cardGroup)  cardGroup.classList.toggle('cp-bv__card--on', key==='group');
  }

  function riseEls(body){
    var els = body ? [].slice.call(body.querySelectorAll('.cp-bv__pill')) : [];
    var tb  = body && body.querySelector('.cp-bv__tierbox');
    if(tb) els.push(tb);
    if(atcBtn) els.push(atcBtn);
    return els;
  }

  function primeHide(body){
    var els = riseEls(body);
    els.forEach(function(e){ e.style.transition='none'; e.classList.add('cp-rise'); });
    (body || atcBtn || document.body).getBoundingClientRect();
    els.forEach(function(e){ e.style.transition=''; });
  }
  var riseTimeouts = [];
  function clearRiseTimers(){ riseTimeouts.forEach(clearTimeout); riseTimeouts = []; }

  function playRise(body){
    var pills = body ? [].slice.call(body.querySelectorAll('.cp-bv__pill')) : [];
    pills.forEach(function(p,i){ riseTimeouts.push(setTimeout(function(){ p.classList.remove('cp-rise'); }, i*70)); });
    var base = pills.length*70;
    var tb = body && body.querySelector('.cp-bv__tierbox');
    if(tb)     riseTimeouts.push(setTimeout(function(){ tb.classList.remove('cp-rise'); }, base+30));
    if(atcBtn) riseTimeouts.push(setTimeout(function(){ atcBtn.classList.remove('cp-rise'); }, base+80));
  }
  function clearRise(body){
    riseEls(body).forEach(function(e){ e.style.transition='none'; e.classList.remove('cp-rise'); e.getBoundingClientRect(); e.style.transition=''; });
  }

  var riseTimer = null;
  function selectCard(key){
    if(!cardByKey[key]) return;
    if(key === 'bundle' && !bundleHasViable()) return;
    if(key === slots[1]){ pickMode(key); return; }
    var animate = !REDUCE && SLIDE_DUR > 0;

    if(!animate){
      var ci0 = slots.indexOf(key), old0 = slots[1];
      slots[1] = key; slots[ci0] = old0;
      slots.forEach(function(k2,i){ if(cardByKey[k2]) cardByKey[k2].style.order = i; });
      pickMode(key);
      clearRise(activeBody());
      return;
    }

    var prevBody = activeBody();

    var first = {};
    for(var kk in cardByKey){ if(cardByKey[kk]) first[kk] = cardByKey[kk].getBoundingClientRect(); }

    var ci = slots.indexOf(key), oldCenter = slots[1];
    slots[1] = key; slots[ci] = oldCenter;
    slots.forEach(function(k2,i){ if(cardByKey[k2]) cardByKey[k2].style.order = i; });

    mode = key;
    setCardsOn(key);

    if(riseTimer){ clearTimeout(riseTimer); riseTimer = null; }
    clearRiseTimers();

    riseEls(prevBody).forEach(function(e){ e.classList.add('cp-rise'); });

    requestAnimationFrame(function(){
      for(var k in cardByKey){
        if(!cardByKey[k]) continue;
        var last = cardByKey[k].getBoundingClientRect();
        var dx = first[k].left - last.left;
        cardByKey[k].style.transition = 'none';
        cardByKey[k].style.transform = dx ? ('translateX('+dx+'px)') : '';
      }
      requestAnimationFrame(function(){
        for(var k in cardByKey){
          if(!cardByKey[k]) continue;
          cardByKey[k].style.transition = 'transform '+SLIDE_DUR+'ms cubic-bezier(.4,0,.2,1)';
          cardByKey[k].style.transform = '';
        }
      });
    });

    riseTimeouts.push(setTimeout(function(){
      setBodyDisplays(mode);
      updateAtc();
      primeHide(bodyForMode(mode));
    }, Math.min(FADE_DUR, SLIDE_DUR)));

    riseTimer = setTimeout(function(){ playRise(bodyForMode(mode)); }, Math.max(SLIDE_DUR, FADE_DUR+20));
  }

  if(cardBundle) cardBundle.addEventListener('click', function(){ selectCard('bundle'); });
  if(cardSingle) cardSingle.addEventListener('click', function(){ selectCard('single'); });
  if(cardGroup)  cardGroup.addEventListener('click', function(){ selectCard('group'); });

  function getCurrentTotalCents(){
    if(mode==='bundle'){
      var t = bundleTiers[selectedTierIdx];
      return (t && t.enough) ? t.discounted : null;
    }
    if(mode==='single') return currentVarPrice;
    var v = volTiers[selectedVolIdx];
    if(!v) return null;
    var qty = v.isParish ? (parishQtyCurrent||v.qty) : v.qty;
    return Math.round(v.price*qty*(1-v.discount/100));
  }

  function updateAtc(){
    if(!atcBtn) return;
    if(mode==='bundle'){
      if(!bundleLoaded){ atcBtn.disabled=true; atcBtn.textContent='Loading…'; syncSticky(); return; }
      var t = bundleTiers[selectedTierIdx];
      if(!t || !t.enough){ atcBtn.disabled=true; atcBtn.textContent = bundleTiers.length? 'Out of Stock' : 'Unavailable'; syncSticky(); return; }
      atcBtn.disabled=false; atcBtn.textContent = atcLabel();
    } else if(mode==='single'){
      atcBtn.disabled=false; atcBtn.textContent = atcLabel();
    } else {
      var v = volTiers[selectedVolIdx];
      if(!v){ atcBtn.disabled=true; atcBtn.textContent='Unavailable'; syncSticky(); return; }
      atcBtn.disabled=false; atcBtn.textContent = atcLabel();
    }
    syncSticky();
  }
  if(atcBtn) atcBtn.addEventListener('click', function(){
    var label = atcLabel();
    if(mode==='bundle'){
      var t = bundleTiers[selectedTierIdx];
      if(!t || !t.enough) return;
      triggerThemeCart(t.variantIds.map(function(id){ return {id:id,quantity:1}; }), atcBtn, label, t.code, t.minQty);
    } else if(mode==='single'){
      triggerThemeCart([{id:currentVarId,quantity:1}], atcBtn, label, null, null);
    } else {
      var v = volTiers[selectedVolIdx];
      if(!v) return;
      var qty = v.isParish ? (parishQtyCurrent||v.qty) : v.qty;
      triggerThemeCart([{id:currentVarId,quantity:qty}], atcBtn, label, v.code, v.minQty);
    }
  });

  var stickyBar=null, stickyBtn=null, stickyPrice=null, stickyTitle=null, stickyVisible=false;

  function stickyTitleText(){
    var base = section.getAttribute('data-cur-title')||'';
    return base + (currentFormat ? ' ' + formatLabel(currentFormat) : '');
  }
  function buildSticky(){
    if(stickyBar || !atcBtn) return;
    stickyBar = document.createElement('div');
    stickyBar.id = 'cp-bv-sticky';
    stickyBar.innerHTML =
      '<div class="cp-bv-sticky__inner">'+
        '<div class="cp-bv-sticky__info">'+
          '<div class="cp-bv-sticky__title"></div>'+
          '<div class="cp-bv-sticky__price"></div>'+
        '</div>'+
        '<button type="button" class="cp-bv-sticky__btn"></button>'+
      '</div>';
    document.body.appendChild(stickyBar);
    stickyBtn   = stickyBar.querySelector('.cp-bv-sticky__btn');
    stickyPrice = stickyBar.querySelector('.cp-bv-sticky__price');
    stickyTitle = stickyBar.querySelector('.cp-bv-sticky__title');
    stickyTitle.textContent = stickyTitleText();

    stickyBtn.addEventListener('click', function(){ if(!atcBtn.disabled) atcBtn.click(); });

    var mo = new MutationObserver(syncSticky);
    mo.observe(atcBtn, {childList:true, characterData:true, subtree:true, attributes:true, attributeFilter:['disabled']});

    var stickyTick = false;
    function refreshStickyVisible(){
      stickyTick = false;
      if(!atcBtn) return;
      var r = atcBtn.getBoundingClientRect();
      var vis = (r.bottom <= 0);
      if(vis !== stickyVisible){ stickyVisible = vis; syncSticky(); }
    }
    function onStickyScroll(){
      if(stickyTick) return;
      stickyTick = true;
      (window.requestAnimationFrame || function(fn){ setTimeout(fn, 16); })(refreshStickyVisible);
    }
    window.addEventListener('scroll', onStickyScroll, {passive:true});
    window.addEventListener('resize', onStickyScroll);

    if('IntersectionObserver' in window){
      try {
        var io = new IntersectionObserver(onStickyScroll, {threshold:0});
        io.observe(atcBtn);
      } catch(e){   }
    }
    refreshStickyVisible();
    syncSticky();
  }
  function syncSticky(){
    if(!stickyBar) return;
    var label = atcBtn.textContent;
    var show = stickyVisible && label !== 'Loading…';
    stickyBar.classList.toggle('cp-bv-sticky--show', show);
    if(!show) return;
    stickyBtn.textContent = label;
    stickyBtn.disabled = atcBtn.disabled;
    if(stickyTitle) stickyTitle.textContent = stickyTitleText();
    var cents = getCurrentTotalCents();
    stickyPrice.textContent = (cents!=null) ? money(cents) : '';
  }

  function onVariantChange(varId) {
    varId = parseInt(varId, 10);
    if(varId === currentVarId) return;
    var v=allVariants.filter(function(x){return x.id===varId;})[0];
    if(!v) return;
    currentVarId    = v.id;
    currentVarPrice = v.price;
    var fmt = detectFormat(v.title);
    currentFormat   = fmt;
    var phys = isPhysical(fmt);
    setPhysicalMode(phys);
    markSelectedSwatch();
    buildSingleUI();
    buildVolumeOptions(v.price);
    if(relatedProds.length){
      var prevIdx = selectedTierIdx;
      buildBundleOptions(relatedProds, fmt);
      if(bundleTiers[prevIdx] && bundleTiers[prevIdx].enough && prevIdx !== selectedTierIdx){
        selectTier(prevIdx);
      }
    }
    updateAtc();
  }

  function watchVariants() {
    window.addEventListener('pageshow', function(e){
      if(e.persisted) window.location.reload();
    });
    var lastPolledId = currentVarId;
    setInterval(function(){
      var params = new URLSearchParams(window.location.search);
      var urlVarId = parseInt(params.get('variant'), 10);
      if(urlVarId && urlVarId !== lastPolledId){
        lastPolledId = urlVarId;
        onVariantChange(urlVarId);
      }
    }, 300);
    window.addEventListener('popstate', function(){
      var params = new URLSearchParams(window.location.search);
      var urlVarId = parseInt(params.get('variant'), 10);
      if(urlVarId && urlVarId !== lastPolledId){
        lastPolledId = urlVarId;
        onVariantChange(urlVarId);
      }
    });
  }

  var BUNDLE_CONFIGS = [
    { label:'Starter Bundle',             short:'Starter',    count:2, discount:10, code:'BUNDLE10', minQty:3  },
    { label:'Best Value Bundle',          short:'Best Value', count:3, discount:15, code:'BUNDLE15', minQty:4  },
    { label:'Complete Collection Bundle', short:'Complete',   count:4, discount:20, code:'BUNDLE20', minQty:5  }
  ];

  function getProductLinks(products, fmt) {
    var curTitle   = section.getAttribute('data-cur-title')||'';
    var curUrl     = section.getAttribute('data-cur-url')||'';
    var curVariant = allVariants.filter(function(v){return v.id===currentVarId;})[0]||allVariants[0];
    var curPrice   = parseInt(curVariant?curVariant.price:0,10);
    var curImg     = appendSize(getVariantImage(curVariant),145);
    var links=[{title:curTitle,url:curUrl,img:curImg,price:curPrice,variantId:currentVarId,isFallback:false,fallbackFmt:''}];
    products.forEach(function(p){
      var result=findVariantByFormat(p.variants,fmt);
      var v=result.variant;
      var varImg=(v&&v.featured_image&&v.featured_image.src)?v.featured_image.src:(p.featured_image||'');
      links.push({title:p.title,url:p.url,img:appendSize(varImg,145),price:parseInt(v.price,10),variantId:v.id,isFallback:result.isFallback,fallbackFmt:result.formatUsed});
    });
    return links;
  }

  function buildImgRow(links, imgClass) {
    var html='<div class="cp-bv__img-row">';
    links.forEach(function(l,i){
      html+='<div class="cp-bv__img-wrap"><a href="'+l.url+'" target="_blank" class="cp-bv__img-link" title="'+l.title+'">';
      html+=l.img?'<img class="'+imgClass+'" src="'+l.img+'" alt="'+l.title+'">':'<div class="'+imgClass+'" style="background:#f0f0f0;"></div>';
      html+='</a>';
      if(l.isFallback) html+='<span class="cp-bv__fmt-note">'+formatLabel(l.fallbackFmt)+'</span>';
      html+='</div>';
      if(i<links.length-1) html+='<span class="cp-bv__plus">+</span>';
    });
    return html+'</div>';
  }

  function buildTitleRow(links) {
    var html='<div class="cp-bv__title-row">';
    links.forEach(function(l,i){
      html+='<a href="'+l.url+'" target="_blank" class="cp-bv__title-link">'+l.title+'</a>';
      if(i<links.length-1) html+='<span class="cp-bv__title-sep">+</span>';
    });
    return html+'</div>';
  }

  function computeTierData(products, fmt) {
    var caps = window.CP_bundlePriceCaps || [3,4,8];
    var cheapest = window.CP_cheapestPrice || currentVarPrice;

    var tierItems = BUNDLE_CONFIGS.map(function(cfg, idx){
      var maxTotal = cheapest * caps[idx];
      var affordable = products.filter(function(p){
        var result = findVariantByFormat(p.variants, fmt);
        return parseInt(result.variant.price, 10) <= (maxTotal - cheapest);
      });
      return affordable.slice(0, cfg.count);
    });

    var tierEnough = tierItems.map(function(items, idx){
      if(idx === 0) return items.length >= BUNDLE_CONFIGS[idx].count;
      return items.length >= BUNDLE_CONFIGS[idx].count && items.length > tierItems[idx-1].length;
    });

    var featuredIdx;
    if(tierEnough[1])      { featuredIdx = 1; }
    else if(tierEnough[0]) { featuredIdx = 0; }
    else if(tierEnough[2]) { featuredIdx = 2; }
    else                   { featuredIdx = 1; }

    return { tierItems:tierItems, tierEnough:tierEnough, featuredIdx:featuredIdx, caps:caps, cheapest:cheapest };
  }

  function bundleMaxViable(){
    var m = 0;
    bundleTiers.forEach(function(t){ if(t.enough) m = Math.max(m, t.cfg.discount); });
    return m;
  }
  function bundleHasViable(){
    return bundleLoaded && bundleTiers.some(function(t){ return t.enough; });
  }

  function updateNudge(){
    var nudge = document.getElementById('cp-bv-nudge');
    if(!nudge) return;
    if(bundleHasViable()){
      var tpl = window.CP_nudgeLabel || 'Bundle it & save up to {pct}% — see bundle →';
      var span = nudge.querySelector('.cp-bv__nudge-txt');
      if(span) span.textContent = tpl.replace('{pct}', bundleMaxViable());
      nudge.style.display = 'inline-flex';
      nudge.onclick = function(){ selectCard('bundle'); };
    } else {
      nudge.style.display = 'none';
    }
  }

  function updateBundleAvailability(){
    var has = bundleHasViable();
    if(cardBundle) cardBundle.classList.toggle('cp-bv__card--bundle-off', !has);
    if(!has && bundleSub) bundleSub.textContent = window.CP_bundleOffMsg || 'Not available for your library';
    if(!has && mode==='bundle') selectCard('single');
    updateNudge();
  }

  function buildBundleOptions(products, fmt) {
    if(!bundleBody) return;
    var td = computeTierData(products, fmt);
    var featuredIdx = td.featuredIdx;
    window.CP_featuredTierIdx = featuredIdx;

    bundleTiers = BUNDLE_CONFIGS.map(function(cfg, idx){
      var items      = td.tierItems[idx];
      var enough     = td.tierEnough[idx];
      var links      = enough ? getProductLinks(items, fmt) : [];
      var totalOrig  = links.reduce(function(s,l){ return s+l.price; }, 0);
      var discounted = enough ? Math.round(totalOrig*(1-cfg.discount/100)) : 0;
      return {
        cfg:cfg, enough:enough, links:links,
        totalOrig:totalOrig, discounted:discounted, savedAmt:totalOrig-discounted,
        variantIds:links.map(function(l){ return l.variantId; }),
        code:cfg.code, minQty:cfg.minQty
      };
    });

    selectedTierIdx = featuredIdx;
    bundleLoaded = true;

    var maxViable = 0;
    bundleTiers.forEach(function(t){ if(t.enough) maxViable = Math.max(maxViable, t.cfg.discount); });
    if(bundleSub) bundleSub.textContent = maxViable ? ('Save up to '+maxViable+'%') : 'See options';

    var BUNDLE_STARS = [1, 5, 3];
    var html = '<div class="cp-bv__pills">';
    bundleTiers.forEach(function(t, idx){
      if(!t.enough) return;

      var on = (idx===selectedTierIdx);
      var starsRow = '<div class="cp-bv__pill-stars">' + new Array((BUNDLE_STARS[idx]||0)+1).join('★') + '</div>';
      html += '<div class="cp-bv__pill'+(on?' cp-bv__pill--on':'')+'" data-tier="'+idx+'">';
      html += starsRow;
      html += '<div class="cp-bv__pill-name">'+t.cfg.short+'</div>';
      html += '<div class="cp-bv__pill-save">Save '+t.cfg.discount+'%</div>';
      html += '</div>';
    });
    html += '</div>';
    html += '<div class="cp-bv__tierbox" id="cp-tierbox"></div>';
    bundleBody.innerHTML = html;

    bundleBody.querySelectorAll('.cp-bv__pill').forEach(function(p){
      p.addEventListener('click', function(){
        var idx = parseInt(p.getAttribute('data-tier'), 10);
        if(!bundleTiers[idx] || !bundleTiers[idx].enough) return;
        selectTier(idx);
      });
    });

    renderTierBox();
    updateAtc();
    updateBundleAvailability();
  }

  function selectTier(idx){
    selectedTierIdx = idx;
    if(bundleBody) bundleBody.querySelectorAll('.cp-bv__pill').forEach(function(p){
      p.classList.toggle('cp-bv__pill--on', parseInt(p.getAttribute('data-tier'),10)===idx);
    });
    renderTierBox();
    updateAtc();
  }

  function renderTierBox(){
    var box = document.getElementById('cp-tierbox');
    if(!box) return;
    var t = bundleTiers[selectedTierIdx];
    if(!t){ box.innerHTML=''; return; }
    if(!t.enough){
      box.innerHTML = '<p class="cp-bv__note">This bundle is out of stock right now — pick another option above.</p>';
      return;
    }
    box.innerHTML =
      buildImgRow(t.links,'cp-bv__opt-img')+
      buildTitleRow(t.links)+
      '<div class="cp-bv__priceline">'+
        '<span class="cp-bv__p-disc">'+money(t.discounted)+'</span>'+
        '<span class="cp-bv__p-orig">'+money(t.totalOrig)+'</span>'+
        '<span class="cp-bv__p-save">Save '+t.cfg.discount+'% · '+money(t.savedAmt)+'</span>'+
      '</div>';
  }

  function openThemeTab(hash){
    var links = [].slice.call(document.querySelectorAll('a[href="'+hash+'"]'));

    var nav = links.filter(function(a){ return a.parentElement && a.parentElement.tagName==='LI'; })[0] || links[0];
    if(nav){ nav.click(); }
    setTimeout(function(){
      var navUl = nav && nav.closest('ul');
      var target = navUl || document.querySelector(hash);
      if(target){ target.scrollIntoView({behavior:'smooth', block:'start'}); }
    }, 320);
  }

  function findJumpTargets(){
    var L = window.CP_jumpLabels || {};
    var targets = [];

    var badge = document.querySelector('.jdgm-prev-badge');
    var revTarget = document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews, .jdgm-widget-actions-wrapper');
    if(badge || revTarget){
      var name = 'Reviews', sub = (L.reviewsSub || 'From verified buyers');
      if(badge){
        var avg = badge.getAttribute('data-average-rating');
        var num = badge.getAttribute('data-number-of-reviews');
        if(avg && num){ name = '★ '+parseFloat(avg).toFixed(1); sub = num+' reviews'; }
      }

      targets.push({name:name, sub:sub, gold:true, action:function(){

        openThemeTab('#tab3');
      }});
    }

    var tab2 = document.querySelector('a[href="#tab2"]');
    if(tab2) targets.push({name:(L.excerptName || 'Outline'), sub:(L.excerptSub || 'Preview the study'),
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6h11"/><path d="M8 12h11"/><path d="M8 18h11"/><path d="M4 6h.01"/><path d="M4 12h.01"/><path d="M4 18h.01"/></svg>',
      action:function(){ openThemeTab('#tab2'); }});

    var desc = document.querySelector('.shopify-section.product_tabs_description, .shopify-section.mass-reading-bottom, #tab1');
    if(desc) targets.push({name:(L.detailsName || 'About'), sub:(L.detailsSub || 'Full details'),
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>',
      action:function(){

        openThemeTab('#tab1');
      }});
    return targets;
  }

  function buildSingleUI(){
    if(!singleBody) return;
    var curTitle = section.getAttribute('data-cur-title')||'';
    var fmtTxt = currentFormat ? ' on '+formatLabel(currentFormat) : '';
    var targets = findJumpTargets();

    var html = '';
    if(targets.length){
      html += '<div class="cp-bv__pills">';
      targets.forEach(function(t, i){
        html += '<div class="cp-bv__pill cp-bv__pill--link" data-jump="'+i+'">';

        html += '<div class="cp-bv__pill-name">'+(t.icon?'<span class="cp-bv__pill-ico">'+t.icon+'</span>':'')+t.name+'</div>';
        html += '<div class="cp-bv__pill-sub">'+t.sub+'</div>';
        html += '</div>';
      });
      html += '</div>';
    }
    html += '<div class="cp-bv__tierbox"'+(targets.length?'':' style="border-top:none; padding-top:2px;"')+'>'+
        '<div class="cp-bv__single-line" style="margin-top:0;">Just <b>'+curTitle+'</b>'+fmtTxt+'.</div>'+
        '<div class="cp-bv__priceline"><span class="cp-bv__p-disc">'+money(currentVarPrice)+'</span></div>'+

        '<button type="button" class="cp-bv__nudge" id="cp-bv-nudge" style="display:none;">'+

          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l9 4.9-9 4.9-9-4.9 9-4.9z"/><path d="M3 12.9l9 4.9 9-4.9"/></svg>'+
          '<span class="cp-bv__nudge-txt"></span>'+
        '</button>'+
      '</div>';
    singleBody.innerHTML = html;

    singleBody.querySelectorAll('[data-jump]').forEach(function(p){
      p.addEventListener('click', function(){
        var t = targets[parseInt(p.getAttribute('data-jump'),10)];
        if(!t) return;
        if(t.action){ t.action(); }
        else if(t.el){ t.el.scrollIntoView({behavior:'smooth', block:'start'}); }
      });
    });

    updateNudge();
  }

  function fetchRelated() {
    fetch('/recommendations/products.json?product_id='+pid+'&limit=20&intent=related')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var cheapest = window.CP_cheapestVariantPrice || currentVarPrice;
      var cheapestDollars = cheapest / 100;

      var caps;
      if(cheapestDollars <= 20)      { caps = [3, 4, 8]; }
      else if(cheapestDollars <= 35) { caps = [2, 3, 5]; }
      else                           { caps = [2, 3, 4]; }
      window.CP_bundlePriceCaps = caps;
      window.CP_cheapestPrice   = cheapest;

      var allCandidates = (data.products || []).filter(function(p){
        if(p.id === pid)      return false;
        if(isBook(p))         return false;
        if(isHiddenSub(p))    return false;
        if(isPurchased(p.id)) return false;
        return true;
      });

      function filterPool(multiplier, allowMultiClass) {
        var classCount = 0;
        return allCandidates.filter(function(p){
          var pIsClass = hasTag(p.tags,'class') ||
            (p.collections && p.collections.some(function(c){ return c.handle==='class'; }));
          if(pIsClass){
            if(!allowMultiClass && classCount >= 1) return false;
            classCount++;
          }
          var cheapestVariantPrice = Math.min.apply(null, p.variants.map(function(v){ return parseInt(v.price,10); }));
          var maxAllowed = cheapest * caps[2] * multiplier;
          return cheapestVariantPrice <= maxAllowed;
        });
      }

      var prods;
      var level1 = filterPool(1, false);
      if(level1.length >= 2){
        prods = level1;
      } else {
        var level2 = filterPool(1.5, false);
        if(level2.length >= 2){
          prods = level2;
          window.CP_bundlePriceCaps = caps.map(function(c){ return c * 1.5; });
        } else {
          var level3 = filterPool(2, false);
          if(level3.length >= 2){
            prods = level3;
            window.CP_bundlePriceCaps = caps.map(function(c){ return c * 2; });
          } else {
            var level4 = filterPool(3, false);
            if(level4.length >= 2){
              prods = level4;
              window.CP_bundlePriceCaps = caps.map(function(c){ return c * 3; });
            } else {
              var level5 = filterPool(3, true);
              prods = level5;
              window.CP_bundlePriceCaps = caps.map(function(c){ return c * 3; });
            }
          }
        }
      }

      relatedProds = prods;

      if(!prods || prods.length < 1){
        bundleLoaded = true;
        bundleTiers = [];
        if(bundleBody) bundleBody.innerHTML='<p class="cp-bv__note">No bundle options available right now — Single Title and Group options are ready above.</p>';
        updateAtc();
        updateBundleAvailability();
        return;
      }

      buildBundleOptions(prods, currentFormat);
    })
    .catch(function(){
      bundleLoaded = true;
      bundleTiers = [];
      if(bundleBody) bundleBody.innerHTML='<p class="cp-bv__note">Could not load bundle options.</p>';
      updateAtc();
      updateBundleAvailability();
    });
  }

  var VOL_ICONS = {
    'Friend': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.2"/><path d="M5.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6"/></svg>',
    'Family': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="8.2" cy="8" r="2.6"/><circle cx="16" cy="9" r="2.2"/><path d="M2.8 19c0-2.8 2.2-4.7 5-4.7 1.7 0 3.1.8 4 2"/><path d="M13.6 19c0-2.4 1.6-4 4-4 1.3 0 2.4.6 3 1.6"/></svg>',
    'Parish': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5v3.5"/><path d="M10.2 4.2h3.6"/><path d="M12 6.2l6 4V21H6V10.2l6-4z"/><path d="M10 21v-3.6a2 2 0 0 1 4 0V21"/></svg>'
  };
  var VOL_CONFIGS_STANDARD = [
    { label:'Friend Discount', short:'Friend',  qty:2,  minQty:2,  isParish:false, discount:10, code:'VOL-FAM-10', featured:false },
    { label:'Family Discount', short:'Family',  qty:3,  minQty:3,  isParish:false, discount:15, code:'VOL-FAM-15', featured:true  },
    { label:'Parish Discount', short:'Parish',  qty:10, minQty:10, isParish:true,  discount:25, code:'VOL-PAR-25', featured:false }
  ];
  var VOL_CONFIGS_CLASS = [
    { label:'Friend Discount', short:'Friend',  qty:2,  minQty:2,  isParish:false, discount:10, code:'VOL-CLASS-10', featured:false },
    { label:'Family Discount', short:'Family',  qty:3,  minQty:3,  isParish:false, discount:15, code:'VOL-CLASS-15', featured:true  },
    { label:'Parish Discount', short:'Parish',  qty:7,  minQty:7,  isParish:true,  discount:35, code:'VOL-CLASS-35', featured:false }
  ];

  function buildVolumeOptions(varPrice) {
    if(!volumeBody) return;
    var price   = parseInt(varPrice, 10);
    var configs = isClass ? VOL_CONFIGS_CLASS : VOL_CONFIGS_STANDARD;

    volTiers = configs.map(function(cfg){
      return { label:cfg.label, short:cfg.short, qty:cfg.qty, minQty:cfg.minQty,
               isParish:cfg.isParish, discount:cfg.discount, code:cfg.code,
               featured:cfg.featured, price:price };
    });
    var featIdx = 0;
    configs.forEach(function(cfg, idx){ if(cfg.featured) featIdx = idx; });
    selectedVolIdx = featIdx;
    parishQtyCurrent = null;

    var volMax = configs.reduce(function(m,c){ return Math.max(m, c.discount); }, 0);
    if(groupSub) groupSub.textContent = 'Save up to '+volMax+'%';

    var html = '<div class="cp-bv__pills">';
    volTiers.forEach(function(t, idx){
      var on = (idx===selectedVolIdx);
      var qtyTxt = t.isParish ? t.minQty+'+' : t.qty;
      var ico = VOL_ICONS[t.short] || '';
      html += '<div class="cp-bv__pill'+(on?' cp-bv__pill--on':'')+'" data-vol="'+idx+'">';
      html += '<div class="cp-bv__pill-name"><span class="cp-bv__pill-ico">'+ico+'</span>'+t.short+' · '+qtyTxt+'</div>';
      html += '<div class="cp-bv__pill-save">Save '+t.discount+'%</div>';
      html += '</div>';
    });
    html += '</div>';
    html += '<div class="cp-bv__tierbox" id="cp-volbox"></div>';
    volumeBody.innerHTML = html;

    volumeBody.querySelectorAll('.cp-bv__pill').forEach(function(p){
      p.addEventListener('click', function(){
        selectedVolIdx = parseInt(p.getAttribute('data-vol'), 10);
        parishQtyCurrent = null;
        volumeBody.querySelectorAll('.cp-bv__pill').forEach(function(q){
          q.classList.toggle('cp-bv__pill--on', q===p);
        });
        renderVolBox();
        updateAtc();
      });
    });

    renderVolBox();
    updateAtc();
  }

  function renderVolBox(){
    var box = document.getElementById('cp-volbox');
    if(!box) return;
    var t = volTiers[selectedVolIdx];
    if(!t){ box.innerHTML=''; return; }
    var qty = t.isParish ? (parishQtyCurrent||t.qty) : t.qty;
    var totalOrig = t.price * qty;
    var totalDisc = Math.round(totalOrig*(1-t.discount/100));
    var perCopy   = Math.round(totalDisc/qty);

    var html = '';
    if(t.isParish){
      html += '<div class="cp-bv__stepper">'+
        '<button type="button" class="cp-bv__qty-btn" id="cp-vq-minus">−</button>'+
        '<span class="cp-bv__qty-num" id="cp-vq-num">'+qty+'</span>'+
        '<button type="button" class="cp-bv__qty-btn" id="cp-vq-plus">+</button>'+
        '<span class="cp-bv__step-lbl">copies</span>'+
      '</div>';
    }
    html += '<div class="cp-bv__priceline">'+
        '<span class="cp-bv__p-disc">'+money(totalDisc)+'</span>'+
        '<span class="cp-bv__p-orig">'+money(totalOrig)+'</span>'+
        '<span class="cp-bv__p-save">Save '+t.discount+'% · '+money(totalOrig-totalDisc)+'</span>'+
      '</div>'+
      '<div class="cp-bv__p-per">'+money(perCopy)+' per copy</div>';
    box.innerHTML = html;

    if(t.isParish){
      var minus = document.getElementById('cp-vq-minus');
      var plus  = document.getElementById('cp-vq-plus');
      if(minus) minus.addEventListener('click', function(e){
        e.stopPropagation();
        parishQtyCurrent = Math.max(t.minQty, (parishQtyCurrent||t.qty) - 1);
        renderVolBox(); updateAtc();
      });
      if(plus) plus.addEventListener('click', function(e){
        e.stopPropagation();
        parishQtyCurrent = (parishQtyCurrent||t.qty) + 1;
        renderVolBox(); updateAtc();
      });
    }
  }

  var initVar = allVariants.filter(function(v){ return v.id===currentVarId; })[0];
  if(initVar){
    currentFormat = detectFormat(initVar.title);
    setPhysicalMode(isPhysical(currentFormat));
    markSelectedSwatch();
    buildSingleUI();
    buildVolumeOptions(initVar.price);
  }
  initSwatchClicks();

  setTimeout(markSelectedSwatch, 800);

  initReAnchor();

  (function addShopPayTip(){
    if(document.getElementById('cp-shoppay-tip')) return;
    var terms = document.querySelector('shopify-payment-terms, .shopify-payment-terms, .shopify-installments');
    if(!terms) return;
    var tip = document.createElement('div');
    tip.id = 'cp-shoppay-tip';
    tip.textContent = 'Tip: select the Shop Pay option during checkout to pay over time.';
    terms.insertAdjacentElement('afterend', tip);
  })();

  buildSticky();
  updateAtc();
  watchVariants();

  function tryReposition(attemptsLeft, callback) {
    var outer  = document.querySelector('.cp-bv-outer');
    var anchor = document.querySelector('.purchase-details.smart-payment-button--true, .purchase-details.smart-payment-button--false');
    if(outer && anchor){
      anchor.parentElement.insertBefore(outer, anchor);
      if(callback) callback();
    } else if(attemptsLeft > 0){
      setTimeout(function(){ tryReposition(attemptsLeft-1, callback); }, 200);
    } else {
      if(callback) callback();
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ tryReposition(5, fetchRelated); });
  } else {
    tryReposition(5, fetchRelated);
  }

})();